<script lang="ts">
  import { t } from '../lib/i18n.svelte'
  let { path }: { path: string } = $props()
</script>

<div class="page page--narrow stack">
  <div>
    <h1>{t('Nothing here')}</h1>
    <p class="muted">
      <code>{path}</code> is not a page in this app.
    </p>
  </div>
  <div class="row">
    <a href="/"><button type="button">{t('Back to the start')}</button></a>
  </div>
</div>
